<ng-container *ngIf="show && delayExpired">
  <div class="d-flex" [ngClass]="{'justify-content-center': center}">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</ng-container>

